export default {
  // 店家與供應商合作狀態
  STORE_RELATIONSHIP_STATUS_REQUEST: 'request', // 審核中
  STORE_RELATIONSHIP_STATUS_COOPERATION: 'cooperation', // 合作
  STORE_RELATIONSHIP_STATUS_REJECT: 'reject', // 拒絕
}